import { useCallback, useMemo } from 'react';
import { toast } from 'react-toastify';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button, { isButtonDisabled } from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useConfirm from 'src/hooks/useConfirm';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import useCancelReceiptsApi from 'src/services/useCancelReceiptsApi';

const CancelReceipt = () => {
  const { confirm } = useConfirm();
  const { isInProgress, receiptData, refreshPage, recId } = useReceiptDetails();
  const { cancelReceipts, cancelReceiptsLoading } = useCancelReceiptsApi();
  const { cancelReceipt: cancelReceiptButtonState } = receiptData;
  const messages = useMemo(
    () => [...(!isInProgress ? ['Receipt not in progress'] : [])],
    [isInProgress]
  );

  const isDisabled = isButtonDisabled(cancelReceiptButtonState);

  const handleCancelReceipt = useCallback(async () => {
    const isAccepted = await confirm({
      title: 'Cancel Receipt',
      content: (
        <p className="mb-2" style={{ lineHeight: '1.5' }}>
          This action will cancel the receipt, Attachment(s) will be unattached and returned to
          queue for reassignment, Do you wish to continue?
        </p>
      ),
      cancelButtonText: 'Cancel',
      cancelColor: 'info',
      confirmButtonText: 'OK',
    });
    if (isAccepted) {
      cancelReceipts({ receiptIds: [Number(recId)] })
        .then((res) => {
          toast.success('Canceled Receipt successfully!');
        })
        .catch(console.error)
        .finally(() => {
          refreshPage();
        });
    }
  }, [cancelReceipts, confirm, recId, refreshPage]);

  return (
    <PopUp
      content={<PopUpContentWrapper type="Error" contents={[...messages]} />}
      show={isDisabled}
    >
      <Button
        onClick={handleCancelReceipt}
        buttonState={cancelReceiptButtonState}
        color="error"
        disabled={isDisabled}
        loading={cancelReceiptsLoading}
      >
        Cancel Receipt
      </Button>
    </PopUp>
  );
};

export default CancelReceipt;
